// import { useEffect, useState } from "react";
// import { useNavigate } from "react-router-dom"; // Import useNavigate for client-side navigation
// import logo from "../../../Assets/img/logo.svg";
// import axios from "axios";
// import { useQuantityContext } from "../../QuantityContext";
// import {
//   Avatar,
//   Button,
//   duration,
//   FormControl,
//   FormControlLabel,
//   FormLabel,
//   Radio,
//   RadioGroup,
// } from "@mui/material";
// import PreviewFileItem, { PreviewImage } from "../../Utilities/PreviewFileItem";

// const VerificationProfile = ({ token, action, requestId, section }) => {
//   const [status, setStatus] = useState("accept");
//   const [comment, setComment] = useState("");
//   const [isPending, setIsPending] = useState(true);
//   const navigate = useNavigate(); // Initialize useNavigate hook for navigation
//   const { handleSuccess, handleFailure } = useQuantityContext();

//   const [userDetails, setUserDetails] = useState({
//     fullName: "",
//     profilePicture: "",
//   });

//   const [educationData, setEducationData] = useState({
//     educationLevel: "",
//     institute: "",
//     board: "",
//     grade: "",
//     startYear: "",
//     endYear: "",
//     degree: "",
//     fieldOfStudy: "",
//   });

//   const [sectionData, setSectionData] = useState({}); // This state holds the details of the user looking for verification. It's content changes with section.

//   const [verificationData, setVerificationData] = useState({
//     attachmentUrls: [],
//     uniqueId: "",
//   });

//   // Function to get details about the user, education item, and verification data
//   const getUserVerificationData = async () => {
//     const config = {
//       params: {
//         requestId,
//       },
//       headers: {
//         "x-api-key": process.env.REACT_APP_API_KEY,
//         "Content-Type": "application/json",
//       },
//     };
//     try {
//       const response = await axios.get(
//         `${process.env.REACT_APP_BACKEND_URL}/adminverify/get-verification-data`,
//         config
//       );

//       if (response.data.status === "ALREADY PROCESSED") {
//         setIsPending(false);
//         return;
//       } else if (response.data.status === "SUCCESS") {
//         const responseData = response.data.data;
//         setUserDetails(responseData.userData);
//         setVerificationData(responseData.verificationData);
//         setSectionSpecificData(
//           responseData.sectionData,
//           responseData.verificationData,
//           responseData.userData
//         );
//         // setEducationData(responseData.educationData);
//       }
//     } catch (error) {
//       console.log("Error fetching verification data:", error);
//     }
//   };

//   useEffect(() => {
//     const fetchUserData = async () => {
//       await getUserVerificationData();
//     };

//     fetchUserData();
//   }, []);

//   const setSectionSpecificData = (
//     sectionData,
//     verificationData,
//     userDetails
//   ) => {
//     if (section === "EDUCATION") {
//       setSectionData({
//         fullName: userDetails.fullName,
//         educationLevel: sectionData.educational_level,
//         institute: sectionData.institute_name,
//         board: sectionData.board,
//         studentId: verificationData.uniqueId,
//         grade: sectionData.percentage,
//         degree: sectionData.degree,
//         fieldOfStudy: sectionData.field_of_study,
//         isCurrent: sectionData.is_pursuing ?? false,
//         duration: sectionData.is_pursuing
//           ? sectionData.start_year + " - Present"
//           : sectionData.start_year + " - " + sectionData.end_year,
//       });
//     } else if (section === "EXPERIENCE") {
//       setSectionData({
//         fullName: userDetails.fullName,
//         companyName: sectionData.company_name,
//         employeeId: verificationData.uniqueId,
//         jobTitle: sectionData.role_title,
//         employmentType: sectionData.employee_type,
//         isCurrent: sectionData.is_currently_working ?? false,
//         duration: sectionData.is_currently_working
//           ? sectionData.start_month +
//           " " +
//           sectionData.start_year +
//           " - Present"
//           : sectionData.start_month +
//           " " +
//           sectionData.start_year +
//           " - " +
//           sectionData.end_month +
//           " " +
//           sectionData.end_year,
//       });
//     } else if (section === "CERTIFICATE") {
//       setSectionData({
//         fullName: userDetails.fullName,
//         organization: sectionData.organisation_name,
//         certificateLink: <a href={verificationData.uniqueId}> Certificate Link </a>,
//         courseTitle: sectionData.course_name,
//         issuedIn: sectionData.issue_date +
//           " " +
//           sectionData.year
//       });
//     }
//   };

//   const sectionContent = {
//     EDUCATION: {
//       formTitle: "Student Verification Request",
//       formDescription: `A ${sectionData.isCurrent ? "current" : "past"
//         } student from your institute/university has initiated a request to
//           verify their student details. Please note that upon verification, a
//           notification will be sent to the student confirming the verification.`,
//       cardTitle: "Student Details",
//     },
//     EXPERIENCE: {
//       formTitle: "Employment Verification Request",
//       formDescription: `A ${sectionData.isCurrent ? "current" : "past"
//         } employee from your company/organization has initiated a request to
//           verify their employment details. Please note that upon verification, a
//           notification will be sent to the employee confirming the verification.`,
//       cardTitle: "Employee Details",
//     },
//     CERTIFICATE: {
//       formTitle: "Certificate Verification Request",
//       formDescription: `A learner enrolled in the mentioned course provided by your company/organization has initiated a request to
//           verify their certification details. Please note that upon verification, a
//           notification will be sent to the learner confirming the verification.`,
//       cardTitle: "Certification Details",
//     },
//   };

//   // Function to handle both accept and reject actions
//   const handleSubmit = async (e) => {
//     e.preventDefault();

//     // Build API URL with the token, requestId, status, and comment
//     const url = `${process.env.REACT_APP_BACKEND_URL}/adminverify/education-response?token=${token}&requestId=${requestId}&action=${status}&comment=${comment}`;

//     const config = {
//       headers: {
//         "x-api-key": "secret_api_key_123456",
//         Authorization: `Bearer ${token}`, // Use the provided token
//         "Content-Type": "application/json",
//       },
//     };

//     try {
//       const response = await axios.get(url, {}, config);
//       console.log("res", response);

//       if (response.data.status === "SUCCESS") {
//         // alert("Verification is completed");
//         handleSuccess("Verification is completed");

//         // Redirect to the main page after successful submission
//         if (localStorage.getItem("objectId")) {
//           navigate('/home'); // Home page for registered NEOIN User
//         } else {
//           navigate('/'); // Sign Up page for non-user
//         }
//       }
//     } catch (error) {
//       // alert(`There was a problem with the request: ${error.message}`);
//       handleFailure(
//         "There was a problem with the request ",
//         `${error.message}`
//       );
//     }
//   };

//   // Handle cancel action: reject the request and reset the form
//   const handleCancel = async () => {
//     setStatus("reject");
//     setComment("");

//     // Build API URL with reject status
//     const url = `${process.env.REACT_APP_BACKEND_URL}/adminverify/education-response?token=${token}&requestId=${requestId}&action=reject&comment=${comment}`;

//     const config = {
//       headers: {
//         "x-api-key": "secret_api_key_123456",
//         Authorization: `Bearer ${token}`,
//         "Content-Type": "application/json",
//       },
//     };

//     try {
//       const response = await axios.get(url, {}, config);
//       console.log("res", response);

//       if (response.data.status === "SUCCESS") {
//         handleFailure("Request rejected");

//         // Redirect to the main page after rejection
//         // navigate('/home'); // Replace '/main' with the route for the main page
//       }
//     } catch (error) {
//       handleFailure(`There was a problem with the request: ${error.message}`);
//     }
//   };

//   const renderSectionData = () => {
//     return Object.keys(sectionData)
//       .filter((key) => key !== "isCurrent")
//       .map((key, index) => {
//         const value = sectionData[key];
//         if (!value) return null; // Skip if the value is empty, null, or undefined

//         // Format the label: Split camelCase, capitalize each word
//         const formattedLabel = key
//           .replace(/([A-Z])/g, " $1") // Add space before each uppercase letter
//           .replace(/^./, (str) => str.toUpperCase()); // Capitalize the first letter of the label

//         return (
//           <div key={key} style={styles.infoTable} className="word-break">
//             <div key={`label-${index}`} style={styles.label}>
//               {formattedLabel}
//             </div>
//             <div key={`value-${index}`} style={styles.value}>
//               : <span className="ps-1"> {value} </span>
//             </div>
//           </div>
//         );
//       });
//   };

//   if (!isPending) {
//     return (
//       <>
//         <div style={styles.parent}>
//           <div style={styles.container}>
//             <div style={styles.header}>
//               <img src={logo} alt="NEOIN logo" style={styles.logo} />
//               <h4>Request Already Processed!</h4>
//             </div>
//             <div className="text-start">
//               This Request has already been processed. Please check the Request
//               ID.
//             </div>
//           </div>
//         </div>
//       </>
//     );
//   }

//   return (
//     <div style={styles.parent}>
//       <div style={styles.cardOuter}>
//         <h4 className="text-center">{sectionContent[section].cardTitle}</h4>
//         <div className="flex-center">
//           {userDetails?.profilePicture ? <div style={styles.imgContainer}>
//             <img
//               src={userDetails?.profilePicture}
//               alt="Profile"
//               className="cover-image"
//             />
//           </div> : <Avatar
//             src="/broken-image.jpg"
//             style={{ height: "100px", width: "100px" }}
//           />}

//         </div>
//         {/* <div style={styles.infoTable}>
//           {[
//             { label: "Education Level", value: educationData.educationLevel },
//             { label: "Institute", value: educationData.institute },
//             { label: "Board/University", value: educationData.board },
//             { label: "Student ID", value: verificationData.uniqueId },
//             { label: "Degree", value: educationData?.degree },
//             { label: "Fields of Study", value: educationData?.fieldOfStudy },
//             { label: "GPA/Grade", value: educationData?.grade },
//             {
//               label: "Year",
//               value: educationData?.startYear + " - " + educationData.endYear,
//             },
//           ]
//             .filter((item) => item.value)
//             .map((item, index) => (
//               <>
//                 <span key={`label-${index}`} style={styles.label}>
//                   {item.label}
//                 </span>
//                 <span key={`value-${index}`} style={styles.value}>
//                   : <span className="ps-2"> {item.value} </span>
//                 </span>
//               </>
//             ))}
//         </div> */}
//         {renderSectionData()}
//         {verificationData?.attachmentUrls?.length > 0 && (
//           <div className="px-3">
//             <div className="my-2 fw-bold">Attachments</div>
//             <div className="d-flex flex-wrap gap-4 align-items-center">
//               {verificationData?.attachmentUrls?.map((attachment, index) =>
//                 attachment?.type.startsWith("image/") ? (
//                   <div key={index}>
//                     <PreviewImage file={attachment} displaySize="80px" />
//                   </div>
//                 ) : null
//               )}
//             </div>
//             <div className="d-flex justify-content-center align-items-start flex-column">
//               {verificationData?.attachmentUrls?.map((attachment, index) =>
//                 !attachment?.type.startsWith("image/") ? (
//                   <div key={index} className="mb-3 w-100">
//                     <PreviewFileItem file={attachment} fontColor="#00000099" />
//                   </div>
//                 ) : null
//               )}
//             </div>
//           </div>
//         )}
//       </div>
//       <div style={styles.container}>
//         <div style={styles.header}>
//           <img src={logo} alt="NEOIN logo" style={styles.logo} />
//           <h4>{sectionContent[section].formTitle}</h4>
//         </div>
//         <div className="text-start">
//           {sectionContent[section].formDescription}
//         </div>
//         <form onSubmit={handleSubmit}>
//           <FormControl style={styles.radioGroup}>
//             <RadioGroup
//               row
//               name="status"
//               value={status}
//               onChange={(e) => setStatus(e.target.value)}
//             >
//               <FormControlLabel
//                 value="accept"
//                 control={<Radio />}
//                 label="Approve"
//               />
//               <FormControlLabel
//                 value="reject"
//                 control={<Radio />}
//                 label="Reject"
//               />
//             </RadioGroup>
//           </FormControl>
//           <textarea
//             value={comment}
//             onChange={(e) => setComment(e.target.value)}
//             placeholder="Comment here"
//             style={styles.textarea}
//           />
//           <div style={styles.buttons}>
//             <Button
//               sx={{ color: "#eb4e3d" }}
//               onClick={handleCancel}
//               className="hover-red-bg"
//             >
//               CANCEL
//             </Button>
//             <Button
//               variant="contained"
//               sx={{ backgroundColor: "#0044C6" }}
//               type="submit"
//             >
//               SUBMIT
//             </Button>
//           </div>
//         </form>
//       </div>
//     </div>
//   );
// };

// const styles = {
//   parent: {
//     position: "relative",
//     display: "flex",
//     justifyContent: "center",
//     gap: "16px",
//     padding: "32px",
//     flexWrap: "wrap-reverse",
//   },
//   cardOuter: {
//     borderRadius: "8px",
//     padding: "16px",
//     minWidth: "300px",
//     width: "auto",
//     boxShadow: "0 0 10px rgba(0, 0, 0, 0.1)"
//   },
//   imgContainer: {
//     height: "110px",
//     width: "110px",
//     borderRadius: "50%",
//     overflow: "hidden",
//     border: "2px solid #DCDCDC88",
//     marginBottom: "8px",
//   },
//   infoTable: {
//     marginTop: "8px",
//     display: "grid",
//     gridTemplateColumns: "150px 1fr", // Two columns: label and value
//     rowGap: "8px",
//     alignItems: "center",
//     color: "rgb(0, 0, 0, 87%)",
//     padding: "0 16px",
//   },
//   label: {
//     fontWeight: "bold",
//     justifySelf: "start", // Align labels to the end
//     paddingRight: "8px", // Add space for the colon alignment
//   },
//   value: {
//     justifySelf: "start", // Align values to the start
//     // maxWidth: "150px", // Restrict width
//     whiteSpace: "nowrap", // Prevent text wrapping
//     overflow: "hidden", // Hide overflow
//     textOverflow: "ellipsis", // Add ellipsis for overflow text
//   },
//   container: {
//     maxWidth: "600px",
//     padding: "20px",
//     borderRadius: "8px",
//     boxShadow: "0 0 10px rgba(0, 0, 0, 0.1)",
//     textAlign: "center",
//   },
//   header: {
//     marginBottom: "20px",
//   },
//   logo: {
//     width: "100px",
//     marginBottom: "10px",
//   },
//   radioGroup: {
//     display: "flex",
//     justifyContent: "start",
//     marginBottom: "20px",
//     marginTop: "6px",
//   },
//   textarea: {
//     width: "100%",
//     height: "100px",
//     marginBottom: "20px",
//     padding: "10px",
//   },
//   buttons: {
//     display: "flex",
//     justifyContent: "right",
//     gap: "16px",
//   },
//   cancelButton: {
//     backgroundColor: "transparent",
//     border: "none",
//     color: "#007BFF",
//     cursor: "pointer",
//     marginRight: "20px",
//   },
//   submitButton: {
//     border: "none",
//     color: "#fff",
//     padding: "10px 20px",
//     borderRadius: "4px",
//     cursor: "pointer",
//     background: "var(--Primary-Color, #0044C6)",
//   },
//   radioGrouplabel: {
//     margin: "10px",
//   },
// };

// export default VerificationProfile;



import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import logo from "../../../Assets/img/logo.svg";
import axios from "axios";
import { useQuantityContext } from "../../QuantityContext";
import {
  Avatar,
  Button,
  FormControl,
  FormControlLabel,
  Radio,
  RadioGroup,
} from "@mui/material";
import PreviewFileItem, { PreviewImage } from "../../Utilities/PreviewFileItem";

const VerificationProfile = ({ token, action, requestId, section }) => {
  const [status, setStatus] = useState("accept");
  const [comment, setComment] = useState("");
  const [isPending, setIsPending] = useState(true);
  const [showCancelMessage, setShowCancelMessage] = useState(false); // New state for cancel message
  const navigate = useNavigate();
  const { handleSuccess, handleFailure } = useQuantityContext();

  const [userDetails, setUserDetails] = useState({
    fullName: "",
    profilePicture: "",
  });

  const [educationData, setEducationData] = useState({
    educationLevel: "",
    institute: "",
    board: "",
    grade: "",
    startYear: "",
    endYear: "",
    degree: "",
    fieldOfStudy: "",
  });

  const [sectionData, setSectionData] = useState({});
  const [verificationData, setVerificationData] = useState({
    attachmentUrls: [],
    uniqueId: "",
  });

  // Function to get details about the user, education item, and verification data
  const getUserVerificationData = async () => {
    const config = {
      params: {
        requestId,
      },
      headers: {
        "x-api-key": process.env.REACT_APP_API_KEY,
        "Content-Type": "application/json",
      },
    };
    try {
      const response = await axios.get(
        `${process.env.REACT_APP_BACKEND_URL}/adminverify/get-verification-data`,
        config
      );

      if (response.data.status === "ALREADY PROCESSED") {
        setIsPending(false);
        return;
      } else if (response.data.status === "SUCCESS") {
        const responseData = response.data.data;
        setUserDetails(responseData.userData);
        setVerificationData(responseData.verificationData);
        setSectionSpecificData(
          responseData.sectionData,
          responseData.verificationData,
          responseData.userData
        );
      }
    } catch (error) {
      console.log("Error fetching verification data:", error);
    }
  };

  useEffect(() => {
    const fetchUserData = async () => {
      await getUserVerificationData();
    };

    fetchUserData();
  }, []);

  const setSectionSpecificData = (
    sectionData,
    verificationData,
    userDetails
  ) => {
    if (section === "EDUCATION") {
      setSectionData({
        fullName: userDetails.fullName,
        educationLevel: sectionData.educational_level,
        institute: sectionData.institute_name,
        board: sectionData.board,
        studentId: verificationData.uniqueId,
        grade: sectionData.percentage,
        degree: sectionData.degree,
        fieldOfStudy: sectionData.field_of_study,
        isCurrent: sectionData.is_pursuing ?? false,
        duration: sectionData.is_pursuing
          ? sectionData.start_year + " - Present"
          : sectionData.start_year + " - " + sectionData.end_year,
      });
    } else if (section === "EXPERIENCE") {
      setSectionData({
        fullName: userDetails.fullName,
        companyName: sectionData.company_name,
        employeeId: verificationData.uniqueId,
        jobTitle: sectionData.role_title,
        employmentType: sectionData.employee_type,
        isCurrent: sectionData.is_currently_working ?? false,
        duration: sectionData.is_currently_working
          ? sectionData.start_month +
          " " +
          sectionData.start_year +
          " - Present"
          : sectionData.start_month +
          " " +
          sectionData.start_year +
          " - " +
          sectionData.end_month +
          " " +
          sectionData.end_year,
      });
    } else if (section === "CERTIFICATE") {
      setSectionData({
        fullName: userDetails.fullName,
        organization: sectionData.organisation_name,
        certificateLink: <a href={verificationData.uniqueId} style={{color:"blue"}}> Certificate Link </a>,
        courseTitle: sectionData.course_name,
        issuedIn: sectionData.issue_date +
          " " +
          sectionData.year
      });
    }
  };

  const sectionContent = {
    EDUCATION: {
      formTitle: "Student Verification Request",
      formDescription: `A ${sectionData.isCurrent ? "current" : "past"
        } student from your institute/university has initiated a request to
          verify their student details. Please note that upon verification, a
          notification will be sent to the student confirming the verification.`,
      cardTitle: "Student Details",
    },
    EXPERIENCE: {
      formTitle: "Employment Verification Request",
      formDescription: `A ${sectionData.isCurrent ? "current" : "past"
        } employee from your company/organization has initiated a request to
          verify their employment details. Please note that upon verification, a
          notification will be sent to the employee confirming the verification.`,
      cardTitle: "Employee Details",
    },
    CERTIFICATE: {
      formTitle: "Certificate Verification Request",
      formDescription: `A learner enrolled in the mentioned course provided by your company/organization has initiated a request to
          verify their certification details. Please note that upon verification, a
          notification will be sent to the learner confirming the verification.`,
      cardTitle: "Certification Details",
    },
  };

  // Function to handle form submission (only called when user clicks SUBMIT)
  const handleSubmit = async (e) => {
    e.preventDefault();
    
    // Only proceed if status is "reject" or "accept" (both are valid)
    // Build API URL with the token, requestId, status, and comment
    const url = `${process.env.REACT_APP_BACKEND_URL}/adminverify/education-response?token=${token}&requestId=${requestId}&action=${status}&comment=${comment}`;

    const config = {
      headers: {
        "x-api-key": "secret_api_key_123456",
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
    };

    try {
      const response = await axios.get(url, {}, config);
      console.log("res", response);

      if (response.data.status === "SUCCESS") {
        if (status === "accept") {
          handleSuccess("Verification is completed");
        } else if (status === "reject") {
          handleFailure("Request rejected");
        }

        // Redirect based on user status
        if (localStorage.getItem("objectId")) {
          navigate('/home');
        } else {
          navigate('/');
        }
      }
    } catch (error) {
      handleFailure(
        "There was a problem with the request ",
        `${error.message}`
      );
    }
  };

  // Handle cancel action: Just show the cancel message without calling API
  const handleCancel = () => {
    setShowCancelMessage(true); // Show the cancel message
    // Optionally reset form or keep as is
    setStatus("accept");
    setComment("");
  };

  // Handle closing the cancel message
  const handleCloseCancelMessage = () => {
    setShowCancelMessage(false);
  };

  const renderSectionData = () => {
    return Object.keys(sectionData)
      .filter((key) => key !== "isCurrent")
      .map((key, index) => {
        const value = sectionData[key];
        if (!value) return null;

        const formattedLabel = key
          .replace(/([A-Z])/g, " $1")
          .replace(/^./, (str) => str.toUpperCase());

        return (
          <div key={key} style={styles.infoTable} className="word-break">
            <div key={`label-${index}`} style={styles.label}>
              {formattedLabel}
            </div>
            <div key={`value-${index}`} style={styles.value}>
              : <span className="ps-1"> {value} </span>
            </div>
          </div>
        );
      });
  };

  // Show "Request Already Processed" message
  if (!isPending) {
    return (
      <div style={styles.parent}>
        <div style={styles.container}>
          <div style={styles.header}>
            <img src={logo} alt="NEOIN logo" style={styles.logo} />
            <h4>Request Already Processed!</h4>
          </div>
          <div className="text-start">
            This Request has already been processed. Please check the Request
            ID.
          </div>
        </div>
      </div>
    );
  }

  // Show "Cancel Message" when cancel is clicked
  if (showCancelMessage) {
    return (
      <div style={styles.parent}>
        <div style={styles.container}>
          <div style={styles.header}>
            <img src={logo} alt="NEOIN logo" style={styles.logo} />
            <h4>Action Cancelled!</h4>
          </div>
          <div className="text-start mb-4">
            You have cancelled the verification process. No action has been taken on this request.
          </div>
          <div style={styles.buttons}>
            <Button
              variant="contained"
              sx={{ backgroundColor: "#0044C6" }}
              onClick={handleCloseCancelMessage}
            >
              Go Back
            </Button>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div style={styles.parent}>
      <div style={styles.cardOuter}>
        <h4 className="text-center">{sectionContent[section].cardTitle}</h4>
        <div className="flex-center">
          {userDetails?.profilePicture ? (
            <div style={styles.imgContainer}>
              <img
                src={userDetails?.profilePicture}
                alt="Profile"
                className="cover-image"
              />
            </div>
          ) : (
            <Avatar
              src="/broken-image.jpg"
              style={{ height: "100px", width: "100px" }}
            />
          )}
        </div>
        {renderSectionData()}
        {verificationData?.attachmentUrls?.length > 0 && (
          <div className="px-3">
            <div className="my-2 fw-bold">Attachments</div>
            <div className="d-flex flex-wrap gap-4 align-items-center">
              {verificationData?.attachmentUrls?.map((attachment, index) =>
                attachment?.type.startsWith("image/") ? (
                  <div key={index}>
                    <PreviewImage file={attachment} displaySize="80px" />
                  </div>
                ) : null
              )}
            </div>
            <div className="d-flex justify-content-center align-items-start flex-column">
              {verificationData?.attachmentUrls?.map((attachment, index) =>
                !attachment?.type.startsWith("image/") ? (
                  <div key={index} className="mb-3 w-100">
                    <PreviewFileItem file={attachment} fontColor="#00000099" />
                  </div>
                ) : null
              )}
            </div>
          </div>
        )}
      </div>
      <div style={styles.container}>
        <div style={styles.header}>
          <img src={logo} alt="NEOIN logo" style={styles.logo} />
          <h4>{sectionContent[section].formTitle}</h4>
        </div>
        <div className="text-start">
          {sectionContent[section].formDescription}
        </div>
        <form onSubmit={handleSubmit}>
          <FormControl style={styles.radioGroup}>
            <RadioGroup
              row
              name="status"
              value={status}
              onChange={(e) => setStatus(e.target.value)}
            >
              <FormControlLabel
                value="accept"
                control={<Radio />}
                label="Approve"
              />
              <FormControlLabel
                value="reject"
                control={<Radio />}
                label="Reject"
              />
            </RadioGroup>
          </FormControl>
          <textarea
            value={comment}
            onChange={(e) => setComment(e.target.value)}
            placeholder="Comment here"
            style={styles.textarea}
          />
          <div style={styles.buttons}>
            <Button
              sx={{ color: "#eb4e3d" }}
              onClick={handleCancel}
              className="hover-red-bg"
              type="button" // Explicitly set type="button" to prevent form submission
            >
              CANCEL
            </Button>
            <Button
              variant="contained"
              sx={{ backgroundColor: "#0044C6" }}
              type="submit"
            >
              SUBMIT
            </Button>
          </div>
        </form>
      </div>
    </div>
  );
};

const styles = {
  parent: {
    position: "relative",
    display: "flex",
    justifyContent: "center",
    gap: "16px",
    padding: "32px",
    flexWrap: "wrap-reverse",
  },
  cardOuter: {
    borderRadius: "8px",
    padding: "16px",
    minWidth: "300px",
    width: "auto",
    boxShadow: "0 0 10px rgba(0, 0, 0, 0.1)"
  },
  imgContainer: {
    height: "110px",
    width: "110px",
    borderRadius: "50%",
    overflow: "hidden",
    border: "2px solid #DCDCDC88",
    marginBottom: "8px",
  },
  infoTable: {
    marginTop: "8px",
    display: "grid",
    gridTemplateColumns: "150px 1fr",
    rowGap: "8px",
    alignItems: "center",
    color: "rgb(0, 0, 0, 87%)",
    padding: "0 16px",
  },
  label: {
    fontWeight: "bold",
    justifySelf: "start",
    paddingRight: "8px",
  },
  value: {
    justifySelf: "start",
    whiteSpace: "nowrap",
    overflow: "hidden",
    textOverflow: "ellipsis",
  },
  container: {
    maxWidth: "600px",
    padding: "20px",
    borderRadius: "8px",
    boxShadow: "0 0 10px rgba(0, 0, 0, 0.1)",
    textAlign: "center",
  },
  header: {
    marginBottom: "20px",
  },
  logo: {
    width: "100px",
    marginBottom: "10px",
  },
  radioGroup: {
    display: "flex",
    justifyContent: "start",
    marginBottom: "20px",
    marginTop: "6px",
  },
  textarea: {
    width: "100%",
    height: "100px",
    marginBottom: "20px",
    padding: "10px",
  },
  buttons: {
    display: "flex",
    justifyContent: "right",
    gap: "16px",
  },
};

export default VerificationProfile;